import { HOME_ENVIRONMENT } from 'config/environments/homeEnvironments';

export const HOME_BASE_DOMAINS = [
  'home.carejourney.com',
  'pre-home.carejourney.com',
  'home-dev.carejourney.com',
  'home-dev-nci.carejourney.com',
  'home-tst.carejourney.com',
  'home-int.carejourney.com'
];

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1'];

export const normalizeTenantSlug = (
  value: string | undefined | null
): string | null => {
  if (!value) {
    return null;
  }

  const slug = value
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return slug || null;
};

export const getCustomerSlugFromHostname = (
  hostname: string = window.location.hostname
): string | null => {
  if (!hostname || LOCAL_HOSTNAMES.includes(hostname)) {
    return null;
  }

  for (const baseDomain of HOME_BASE_DOMAINS) {
    if (hostname === baseDomain) {
      return null;
    }

    const suffix = `.${baseDomain}`;
    if (hostname.endsWith(suffix)) {
      const slug = hostname.slice(0, -suffix.length);
      if (slug && !slug.includes('.')) {
        return normalizeTenantSlug(slug);
      }
    }
  }

  return null;
};

export const getTenantOrigin = (): string => {
  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin;
  }

  return HOME_ENVIRONMENT.BASE_APP_URL;
};

export const getTenantHomeUrl = (): string => `${getTenantOrigin()}/home`;

export const tenantSlugMatchesUser = (
  urlSlug: string | null,
  memberName: string | undefined | null
): boolean => {
  if (!urlSlug) {
    return true;
  }

  return normalizeTenantSlug(memberName) === normalizeTenantSlug(urlSlug);
};
